import ApiFetch from 'utils/apiFetch';

const ApiFetchInstance = ApiFetch();

/**
 * Código propio del referidor.
 * Método verificado en localhost autenticado: GET → 200 { CodigoReferidor }.
 * POST al mismo path → 500 "Request method 'POST' not supported".
 */
export const REFERRER_CODE_PATH = '/users/clients/referrer-code';

/** Lista de referidos (sin CodigoReferidor en la respuesta). */
export const REFERRAL_CODE_PATH = '/users/clients/referral-code';

export default {
  /**
   * Consulta el CodigoReferidor de la sesión actual.
   * Sin body: cookie + origin vía ApiFetch.
   */
  getReferrerCode() {
    return ApiFetchInstance.get(REFERRER_CODE_PATH);
  },

  /**
   * Consulta la lista de referidos.
   * Sin body: cookie + origin vía ApiFetch.
   */
  getReferralCode() {
    return ApiFetchInstance.post(REFERRAL_CODE_PATH);
  },
};
